export default __webpack_public_path__ + "static/Kalnia-VariableFont_wdth,wght-ea93935ecef30006ea44cec56e180cfa.ttf";